var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centralized-issue-name-table-cell",on:{"click":_vm.openIssueDetails}},[_c('div',{staticClass:"centralized-issue-name-table-cell__name"},[_vm._v(" "+_vm._s(_vm.getName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }